export const DEFAULT_NAMESPACE = 'common';
export const DEFAULT_LNG = 'en';
